"use client";
import LogoLink from "../../components/navbar/LogoLink";
import VersuriSearchBox from "./VersuriSearchBox";

import AppBar from "@mui/material/AppBar";
import Container from "@mui/material/Container";
import Toolbar from "@mui/material/Toolbar";
import StoreFrontRightArea from "~/components/navbar/StoreFrontRightArea";

interface LyricsNavbarProps {
  initialQuery?: string;
}

export default function VersuriNavbar({ initialQuery = "" }: LyricsNavbarProps) {
  return (
    <AppBar
      position="static"
      enableColorOnDark
      color="default"
      elevation={0}
      sx={{
        bgcolor: "color-mix(in srgb, var(--mui-palette-background-default), transparent 60%)",
        color: "background.contrastText",
        transition: "all 0.3s ease-in-out",
        colorScheme: "light",
        // borderBottom: "1px solid",
        // borderColor: "divider",
      }}
    >
      <Container maxWidth="xl" sx={{ px: { xs: 0, md: 2 } }}>
        <Toolbar
          disableGutters
          sx={{
            justifyContent: "stretch",
            minHeight: { xs: 48, md: 56 },
          }}
        >
          <LogoLink />

          <VersuriSearchBox initialQuery={initialQuery} />

          <StoreFrontRightArea />
        </Toolbar>
      </Container>
    </AppBar>
  );
}
